import moment from "moment";
import React from "react";

import planeLogo from "../../../images/planelogo.png";
import customTime from "../../../utils/customTime";
import "../style.css";
import { getCarrierInfo, getFlightName } from "../../../utils/flightInfo";

const formatDuration = (dur) => {
  if (!dur || !dur.startsWith("PT")) return "";
  const m = dur.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
  return m
    ? [m[1] && `${m[1]}h`, m[2] && `${m[2]}m`].filter(Boolean).join(" ")
    : "";
};

const AmadeusTicketDetail = ({
  data,
  passengerList,
  tickets,
  cabin,
  validatingAirlineCodes,
  index,
}) => {
  function customDate(date) {
    let d = date?.split("T")?.[0];
    return moment(d).format("dddd DD MMM");
  }

  const getTicketForPassenger = (travelerId) => {
    const ticket = tickets?.find((t) => t?.travelerId === travelerId);
    return ticket?.documentNumber;
  };

  const flightNumber = `${data?.carrierCode || ""} ${
    data?.number || ""
  }`.trim();

  return (
    <div
      style={{
        pageBreakBefore: index && index % 2 === 0 ? "always" : "auto",
        marginTop: index && index % 2 === 0 ? "35px" : "0px",
      }}
    >
      <div className="line"></div>
      <div className="mt-1 mb-2 dep-daycar">
        <div className="flex justify-start space-x-1">
          <img src={planeLogo} alt="" style={{ width: "25px" }} />
          <div className="flex space-x-4 item-center">
            <h2 className="">
              DEPARTURE:{" "}
              <span className="text-lg font-bold">
                {customDate(data?.departure?.at)}
              </span>
            </h2>
            <p className="mt-1 gray-color">
              Please verify flight times prior to departure
            </p>
          </div>
        </div>
      </div>
      {/* end of departure date header */}
      <div className="pass-details-card">
        <div className="pass-det gray-bg-color">
          <h2 className="text-2xl tracking-wide text-gray-700 font-bolder">
            {
              getCarrierInfo(validatingAirlineCodes?.[0] || data?.carrierCode)
                ?.Name
            }
          </h2>
          <span className="bold">{flightNumber}</span>

          <div className="my-1">
            <p>Duration:</p>
            <p>{formatDuration(data?.duration)}</p>
          </div>
          <div className="my-1">
            <p>Cabin:</p>
            <p>{cabin || "ECONOMY"}</p>
          </div>
          <p className="my-1">Status: Confirmed</p>
        </div>
        <div className="pass-det-container">
          <div className="pass-det-2">
            <div className="pass-det-2-top">
              <div className="w-1/2">
                <p className="text-lg font-bolder">
                  {data?.departure?.iataCode}
                </p>
                <p className="tracking-wider">
                  {getFlightName(data?.departure?.iataCode)}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-lg font-bolder">{data?.arrival?.iataCode}</p>
                <p className="tracking-wider">
                  {getFlightName(data?.arrival?.iataCode)}
                </p>
              </div>
            </div>
            <div className="pass-det-time">
              <div className="dep-time">
                <p className="tracking-wide text-gray-700">
                  Departing At: <br />
                  <span className="text-2xl font-bold">
                    {customTime(data?.departure?.at)}
                  </span>
                </p>
                <p>Terminal:</p>
                <p className="tracking-wide">
                  {data?.departure?.terminal
                    ? data.departure.terminal
                    : "Not Available"}
                </p>
              </div>
              <div className="arr-time">
                <p className="tracking-wide text-gray-700">
                  Arriving At: <br />
                  <span className="text-2xl font-bold">
                    {customTime(data?.arrival?.at)}
                  </span>
                </p>
                <p>Terminal:</p>
                <p className="tracking-wide">
                  {data?.arrival?.terminal
                    ? data.arrival.terminal
                    : "Not Available"}
                </p>
              </div>
            </div>
          </div>
          <div className="mt-2 space-y-2 pass-plane">
            <h1>Flight Number: {flightNumber}</h1>
          </div>
        </div>
      </div>
      <div className="mt-12 pass-bottom sm:mt-10">
        <div className="bottom-pass-details gray-bg-color">
          <p>Passenger Name:</p>
          <p>Seats:</p>
          <p>eTicket Receipt(s):</p>
        </div>
        <div className="bottom-pass-details">
          <div className="flex flex-col">
            {passengerList?.map((passenger, i) => (
              <p key={i}>
                {">> "}
                {(passenger?.name?.title || passenger?.title) &&
                  `${passenger?.name?.title || passenger?.title}. `}
                {passenger?.name?.firstName
                  ? passenger?.name?.firstName + " " + passenger?.name?.lastName
                  : (passenger?.name?.givenName || passenger?.firstName || "") +
                    " " +
                    (passenger?.name?.surname || passenger?.lastName || "")}
              </p>
            ))}
          </div>

          <div className="ml-3">
            {passengerList?.map((_, i) => (
              <p key={i}>Check-In Required</p>
            ))}
          </div>
          <div>
            {passengerList?.map((passenger, i) => (
              <div key={i}>{getTicketForPassenger(passenger?.id)}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmadeusTicketDetail;
